module.exports = __webpack_public_path__ + "img/MessageButton.53b1d2a5.svg";